import Highcharts from 'highcharts';
import _ from 'lodash';

export const grandTotal = 'Grand total';

export const chartWithGroups = (chart, ...groups) => {
  const chartGroups = _.get(chart, 'userOptions.groups', []);
  return !!chart && groups.every((g) => chartGroups.includes(g));
};

export const showMedian = (show, group) => {
  const charts = Highcharts.charts.filter((chart) => chartWithGroups(chart, group, 'median'));

  charts.forEach((chart) => {
    const cartVar = chart;
    cartVar.userOptions.medianLine = show;
    cartVar.redraw();
  });
};

export const showCumulative = (show, group) => {
  const charts = Highcharts.charts.filter((chart) => chartWithGroups(chart, group, 'cumulative'));

  charts.forEach((chart) => {
    const cartVar = chart;
    cartVar.userOptions.cumulative = show;
    cartVar.redraw();
  });
};

export const showAverage = (show, group) => {
  const charts = Highcharts.charts.filter((chart) => chartWithGroups(chart, group, 'average'));

  charts.forEach((chart) => {
    const cartVar = chart;
    cartVar.userOptions.averageLine = show;
    chart.redraw();
  });
};

export const showTrend = (show, group) => {
  const charts = Highcharts.charts.filter((chart) => chartWithGroups(chart, group, 'trend'));

  charts.forEach((chart) => {
    const cartVar = chart;
    cartVar.userOptions.trendLine = show;
    chart.redraw();
  });
};

export const changeAdaptiveState = (isAdaptive, group) => {
  const charts = Highcharts.charts.filter((chart) => chartWithGroups(chart, group, 'adaptive'));

  charts.forEach((chart) => {
    const adaptive = !!chart.userOptions.adaptive;
    const isZero = chart.series
      .filter((s) => s.visible)
      .flatMap(({ data }) => data)
      .some(({ y }) => y === 0);
    // если в данных присутствует 0, то adaptive не имеет смысла
    if (!isZero) {
      chart.yAxis[0].update({ min: isAdaptive || adaptive ? undefined : 0 });
    }
  });
};
